import React, { useState, useEffect, useMemo } from 'react';
import { Sparkles } from 'lucide-react';
import './Skills.css';

// --- LOGHI SVG VETTORIALI STILIZZATI ---
const SvgMaya = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full text-[#0696d7]" fill="currentColor">
    <path d="M20,75 L42,22 L50,42 L58,22 L80,75 L68,75 L58,48 L50,68 L42,48 L32,75 Z" />
    <path d="M50,15 C52.5,15 54.5,17 54.5,19.5 C54.5,22 52.5,24 50,24 C47.5,24 45.5,22 45.5,19.5 C45.5,17 47.5,15 50,15 Z" opacity="0.8" />
  </svg>
);

const SvgZBrush = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full text-[#ec2024]" fill="currentColor">
    <path d="M18,22 L82,22 L82,34 L40,68 L82,68 L82,80 L18,80 L18,68 L60,34 L18,34 Z" />
    <path d="M54,42 L66,32 L78,42 L72,58 L54,58 Z" opacity="0.6" />
  </svg>
);

const SvgBlender = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full text-[#e87d0d]" fill="currentColor">
    <path d="M50,85 C28.5,85 11,67.5 11,46 C11,27.5 24,12 41.5,8.5 C44.5,8 47.5,9.5 48.5,12.5 C49.5,15.5 48,18.5 45,19.5 C32,22 23,33 23,46 C23,61 35,73 50,73 C65,73 77,61 77,46 C77,42.5 76.3,39 75,36 C73.8,33 75.3,29.5 78.3,28.3 C81.3,27 84.8,28.5 86,31.5 C88,36 89,41 89,46 C89,67.5 71.5,85 50,85 Z" />
    <path d="M50,58 C43.4,58 38,52.6 38,46 C38,39.4 43.4,34 50,34 C56.6,34 62,39.4 62,46 C62,52.6 56.6,58 50,58 Z" />
    <path d="M58,25 C64,28 72,25 78,16 C84,7 86,0 86,0 C86,0 77,3 71,9 C65,15 62,20 58,25 Z" fill="#4895ef" />
  </svg>
);

const SvgSubstance = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full text-[#df1f26]" fill="currentColor">
    <rect x="12" y="12" width="76" height="76" rx="16" fill="none" stroke="currentColor" strokeWidth="6" />
    <path d="M28,32 L46,32 C52,32 56,35 56,40 C56,45 52,48 46,48 L36,48 L36,68 L28,68 Z M36,41 L36,41.5 L45,41.5 C48,41.5 50,40.5 50,39.5 C50,38 48,37 45,37 L36,37 Z" />
    <path d="M68,36 L68,46 L60,46 L60,52 L68,52 L68,68 L76,68 L76,52 L82,52 L82,46 L76,46 L76,36 Z" />
  </svg>
);

const SvgUnreal = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full text-[#ffffff]" fill="currentColor">
    <circle cx="50" cy="50" r="38" fill="none" stroke="currentColor" strokeWidth="5" />
    <path d="M50,19 C48,19 46,21 46,23 L46,35 C46,37 48,39 50,39 C52,39 54,37 54,35 L54,23 C54,21 52,19 50,19 Z" />
    <path d="M50,81 C52,81 54,79 54,77 L54,65 C54,63 52,61 50,61 C48,61 46,63 46,65 L46,77 C46,79 48,81 50,81 Z" />
    <path d="M38,40 C28,40 28,60 38,60 C42,60 45,55 45,50 L45,30 L36,30 L36,35 L40,35 L40,43 C38,43 35,46 35,50 C35,54 38,55 40,55 L40,50 C40,45 42,42 46,42 C54,42 54,58 46,58 C43,58 41,56 40,54 L40,58 C41,60 43,62 46,62 C58,62 58,38 46,38 C43,38 40,40 38,40 Z" />
  </svg>
);

const SvgUnity = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full text-[#c2c2c2]" fill="currentColor">
    <path d="M50,10 L84.6,30 L84.6,70 L50,90 L15.4,70 L15.4,30 Z" fill="none" stroke="currentColor" strokeWidth="5" />
    <path d="M50,10 L50,42 L77,26 Z" opacity="0.7" />
    <path d="M84.6,70 L52,52 L78,67 Z" opacity="0.8" />
    <path d="M15.4,70 L48,52 L22,67 Z" opacity="0.9" />
    <path d="M50,42 L22,26 L15.4,30 Z" opacity="0.6" />
    <circle cx="50" cy="48" r="7" />
  </svg>
);

const SvgPhotoshop = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full text-[#31a8ff]" fill="currentColor">
    <rect x="10" y="10" width="80" height="80" rx="12" fill="#001d3d" stroke="currentColor" strokeWidth="5" />
    <text x="24" y="66" fontSize="38" fontWeight="bold" fontFamily="Arial, sans-serif" fill="#31a8ff">P</text>
    <text x="51" y="66" fontSize="38" fontWeight="bold" fontFamily="Arial, sans-serif" fill="#31a8ff">s</text>
  </svg>
);

const SvgAfterEffects = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full text-[#9987ff]" fill="currentColor">
    <rect x="10" y="10" width="80" height="80" rx="12" fill="#1d003d" stroke="currentColor" strokeWidth="5" />
    <text x="22" y="66" fontSize="38" fontWeight="bold" fontFamily="Arial, sans-serif" fill="#9987ff">A</text>
    <text x="50" y="66" fontSize="38" fontWeight="bold" fontFamily="Arial, sans-serif" fill="#9987ff">e</text>
  </svg>
);

// --- DATA SET SOFTWARE ---
const SOFTWARE_DATA = [
  {
    id: 'maya',
    name: 'Autodesk Maya',
    category: 'Hard Surface & UV Mapping',
    level: 90,
    color: '#0696d7',
    icon: <SvgMaya />,
    description: 'Primary software for complex polygonal and hard-surface modeling. Used to create clean meshes, real-time optimized topology, and non-overlapping UV layouts.',
    specialties: ['Sub-D Modeling', 'Professional Retopology', 'Optimized UV Mapping', 'Basic Rigging']
  },
  {
    id: 'zbrush',
    name: 'Pixologic ZBrush',
    category: 'Digital Sculpting & High-Poly',
    level: 90,
    color: '#ec2024',
    icon: <SvgZBrush />,
    description: 'Core digital sculpting workflow tool. Used for high-resolution organic modeling, micro-surface detailing (wrinkles, pores, cracks), and mesh processing via Dynamesh and ZRemesher.',
    specialties: ['Organic Sculpting', 'Normal/AO Map Baking', 'Dynamesh/ZRemesh Workflow', 'Micro-Detailing']
  },
  {
    id: 'blender',
    name: 'Blender 3D',
    category: 'Generalist 3D & Lookdev',
    level: 85,
    color: '#e87d0d',
    icon: <SvgBlender />,
    description: 'Versatile 3D suite used for fast concepting, physics simulations, rapid Eevee/Cycles rendering, procedural modeling, and general look development.',
    specialties: ['Lookdev & Materials', 'Cycles & Eevee Rendering', 'Procedural Modeling', 'Rapid Prototyping']
  },
  {
    id: 'substance',
    name: 'Substance Painter',
    category: 'PBR Texturing',
    level: 90,
    color: '#df1f26',
    icon: <SvgSubstance />,
    description: 'Industry standard for PBR (Physically Based Rendering) 3D texturing. Creation of custom smart materials, high-resolution texture painting, and high-precision baking of curvature, normal, and occlusion maps.',
    specialties: ['PBR Metallic/Roughness', 'Custom Smart Materials', 'High-to-Low Poly Baking', 'Hand-Painted Texturing']
  },
  {
    id: 'unreal',
    name: 'Unreal Engine 5',
    category: 'Real-Time Rendering & Assembly',
    level: 80,
    color: '#ffffff',
    icon: <SvgUnreal />,
    description: 'Real-time rendering engine used for 3D environment assembly and final output. Implements Lumen (dynamic global illumination), Nanite (virtualized geometry), complex shaders, and performance optimization.',
    specialties: ['Level Design', 'Lumen & Nanite Workflow', 'Parent & Instanced Materials', 'Mesh & Draw Call Optimization']
  },
  {
    id: 'unity',
    name: 'Unity 3D',
    category: 'Game Engine & WebGL',
    level: 75,
    color: '#c2c2c2',
    colorHex2d: '#38bdf8',
    icon: <SvgUnity />,
    description: 'Used for game development, real-time interactive applications, and asset optimization for WebGL and mobile platforms.',
    specialties: ['Asset Integration', 'Universal Render Pipeline (URP)', 'WebGL Optimization', 'Basic C# Scripting']
  },
  {
    id: 'photoshop',
    name: 'Adobe Photoshop',
    category: '2D Post-Process & Textures',
    level: 90,
    color: '#31a8ff',
    icon: <SvgPhotoshop />,
    description: 'Essential for photo editing and 2D texture processing. Used to create custom decals, seamless patterns, alpha textures, and post-processing of static 3D renders.',
    specialties: ['Texture Editing', 'Alpha Channel Creation', 'Render Post-Processing', 'Concept Matte Painting']
  },
  {
    id: 'aftereffects',
    name: 'Adobe After Effects',
    category: 'Motion Graphics & VFX',
    level: 80,
    color: '#9987ff',
    icon: <SvgAfterEffects />,
    description: 'Used for video compositing of 3D renders, adding particle effects, cinematic color grading, dynamic transitions, and editing professional showreels.',
    specialties: ['Render Compositing', 'Color Grading & Effects', 'Motion Graphics', 'Showreel Editing']
  }
];

// --- MAIN COMPONENT ---
const Skills = () => {
  const [activeId, setActiveId] = useState('maya');
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 50);
    return () => clearTimeout(timer);
  }, [activeId]);

  const activeSoftware = useMemo(() => {
    return SOFTWARE_DATA.find(soft => soft.id === activeId) || SOFTWARE_DATA[0];
  }, [activeId]);

  return (
    <section id="skills" className="skills-section">
      <div className="skills-container">
        
        {/* Header Sezione */}
        <div className="skills-header">
          <div className="skills-tag">
            <Sparkles size={16} />
            <span>Tech Stack & Tools</span>
          </div>
          <h2 className="skills-title">
            Creative <span className="text-purple-gradient">Workflow</span> & Software Expertise
          </h2>
          <p className="skills-subtitle">
            Select any software below to explore my technical proficiency, primary focus areas, and production pipeline.
          </p>
        </div>

        <div className="skills-content-layout">
          
          {/* Selettore Griglia Loghi 2D */}
          <div className="skills-selector-grid">
            {SOFTWARE_DATA.map((soft) => {
              const isActive = soft.id === activeId;
              const accentColor = soft.colorHex2d || soft.color;
              return (
                <button
                  key={soft.id}
                  className={`skill-card-item ${isActive ? 'active' : ''}`}
                  style={{ '--soft-accent': accentColor }}
                  onClick={() => setActiveId(soft.id)}
                >
                  <div className="skill-card-icon">
                    {soft.icon}
                  </div>
                  <div className="skill-card-text">
                    <span className="skill-card-name">{soft.name}</span>
                    <span className="skill-card-category">{soft.category.split('&')[0]}</span>
                  </div>
                  <div className="skill-card-badge">
                    <span>{soft.level}%</span>
                  </div>
                </button>
              );
            })}
          </div>

          {/* Card Dettaglio Software Glassmorphism */}
          <div 
            className="skill-details-panel"
            style={{ '--panel-accent': activeSoftware.color }}
          >
            <div className="panel-header">
              <div className="panel-icon-box">
                <div style={{ width: '48px', height: '48px' }}>
                  {activeSoftware.icon}
                </div>
              </div>
              
              <div className="panel-title-box">
                <h3 className="panel-software-name">{activeSoftware.name}</h3>
                <span className="panel-software-category">{activeSoftware.category}</span>
              </div>
            </div>

            <div className="panel-level-box">
              <div className="level-labels">
                <span className="level-title">Proficiency Level</span>
                <span className="level-percentage">{activeSoftware.level}%</span>
              </div>
              <div className="level-bar-bg">
                <div 
                  className="level-bar-fill" 
                  style={{ width: isLoaded ? `${activeSoftware.level}%` : '0%' }}
                />
              </div>
            </div>

            <div className="panel-description-box">
              <span className="box-label">Workflow Overview</span>
              <p className="panel-description">{activeSoftware.description}</p>
            </div>

            <div className="panel-specialties-box">
              <span className="box-label">Primary Focus Areas</span>
              <div className="specialties-tags">
                {activeSoftware.specialties.map((spec, idx) => (
                  <span key={idx} className="specialty-pill">
                    {spec}
                  </span>
                ))}
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default Skills;


